function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#b0bec5",
  d: "M35 5H7a4 4 0 00-4 4v17a4 4 0 004 4h28a4 4 0 004-4V9a4 4 0 00-4-4z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#607d8b",
  d: "M4.088 6.273a3.98 3.98 0 00-.961 1.774L21 21 38.873 8.047a3.971 3.971 0 00-.961-1.773L21 18.531 4.088 6.273z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#cfd8dc",
  d: "M41 16H13a4 4 0 00-4 4v17a4 4 0 004 4h28a4 4 0 004-4V20a4 4 0 00-4-4z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#78909c",
  d: "M10.088 17.273a3.977 3.977 0 00-.961 1.773L27 32l17.873-12.953a3.971 3.971 0 00-.961-1.773L27 29.531 10.088 17.273z"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2196f3",
  d: "M48 40l-9-8v16z"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#2196f3",
  d: "M27 37h13v6H27z"
});

var Svg4Email = function Svg4Email(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: 96,
    height: 96,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(Svg4Email, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/4-email.820f5afe.svg";
export { ForwardRef as ReactComponent };